/** Labels of `entity_card` fields (legacy `verification.json`). */
export const LEGAL_LABELS: Record<string, string> = {
  name: 'Наименование предприятия',
  short_name: 'Краткое наименование',
  legal_address: 'Юридический адрес',
  post_address: 'Почтовый адрес',
  phone: 'Телефон',
  email: 'Электронная почта',
  director: 'Генеральный директор',
  director_basis: 'Полномочия генерального директора',
  chief_accountant: 'Главный бухгалтер',
  by_taxpayer_number: 'Учётный номер плательщика УНП',
  by_bank_name: 'Наименование банка',
  by_bank_id_number: 'Банковский идентификационный код БИК',
  by_classification_number: 'Основной госсударственный классификатор предприятий и организаций ОКПО',
  by_bank_address: 'Адрес банка',
  by_account_number: 'Номер рассчетного счета',
  by_correspond_account_number: 'Номер корреспондентского счета',
  kz_taxpayer_number: 'Учётный номер плательщика УНП',
  kz_bis_taxpayer_number: 'Бизнес-идентификационный номер БИН',
  kz_bank_name: 'Наименование банка',
  kz_bank_id_number: 'Банковский идентификационный код БИК',
  kz_bank_address: 'Адрес банка',
  kz_account_number: 'Номер рассчетного счета',
  kz_beneficiary_code: 'Код Бенефициара КБЕ',
  ru_taxpayer_number: 'Индивидуальный налоговый номер ИНН',
  ru_registration_reason_number: 'Код причины постановки на учет КПП',
  ru_registration_number: 'Основной госсударственный регистрационный номер ОГРН',
  ru_classification_number: 'Общероссийский классификатор предприятий и организаций ОКПО',
  ru_area_classification_number:
    'Общероссийский классификатор объектов административно-территориального деления ОКАТО',
  ru_municipality_number: 'Общероссийский классификатор территорий муниципальных образований ОКТМО',
  ru_goverment_department_number:
    'Общероссийский классификатор органов государственной власти и управления ОКОГУ',
  ru_ownership_form_number: 'Общероссийский классификатор форм собственности ОКФС',
  ru_economic_activity_number: 'Общероссийский классификатор видов экономической деятельности ОКВЭД',
  ru_bank_name: 'Наименование банка',
  ru_bank_id_number: 'Банковский идентификационный код БИК',
  ru_bank_address: 'Адрес банка',
  ru_account_number: 'Номер рассчетного счета',
  ru_correspond_account_number: 'Номер корреспондентского счета',
};
